import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("deliver_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const resolveUrl = (u) => (!u ? "" : u.startsWith("/") ? `${BACKEND_URL}${u}` : u);

export const pdfHref = (brand, doc) => {
  const d = doc || (brand?.pdfs?.[0]) || (brand?.pdf_url ? { url: brand.pdf_url, filename: brand.pdf_name } : null);
  if (!d?.url) return null;
  const base = resolveUrl(d.url);
  if (!d.url.startsWith("/")) return base;
  return `${base}?download=${encodeURIComponent(pdfFilename(d.filename, brand?.name))}`;
};

// Build a safe, human-friendly download filename that always ends in .pdf
// e.g. "The Fermentary Range" -> "The-Fermentary-Range.pdf", "Moira Mac's" -> "Moira-Macs.pdf"
export const pdfFilename = (raw, brandName) => {
  let base = String(raw || `${brandName || "range"}-catalogue`).trim();
  base = base.replace(/\.pdf$/i, "");                 // strip any existing extension
  base = base.replace(/[^\w\s-]/g, "").trim().replace(/\s+/g, "-"); // sanitize to safe hyphenated name
  if (!base) base = `${(brandName || "range").replace(/[^\w\s-]/g, "").trim().replace(/\s+/g, "-") || "range"}-catalogue`;
  return `${base}.pdf`;
};

export const brandDocs = (brand) => (brand?.pdfs?.length ? brand.pdfs : brand?.pdf_url ? [{ label: "Range PDF", url: brand.pdf_url, filename: brand.pdf_name }] : []);

export const formatApiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
};

export const COMPANY = {
  name: "Deliver Pty Ltd",
  abn: "77 144 771 406",
  address: "39 Sunblest Crescent, Mount Druitt NSW 2770",
  phone: "(02) 9799 8483",
  phoneHref: "tel:+61297998483",
  email: "info@deliverfood.com.au",
  hours: "Monday – Friday, 6:00am – 4:00pm",
  instagram: "https://www.instagram.com/deliver_food/",
};
